module.exports = __webpack_public_path__ + "img/mint_booster_nft.7e6cb6bf.png";